import React, { useCallback, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  ButtonGroup,
  IconButton,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import { PlayArrow, Pause, SkipNext, SkipPrevious } from '@mui/icons-material';
import {
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
  NavigateNext as NavigateNextIcon,
  NavigateBefore as NavigateBeforeIcon,
  PlayArrow as PlayArrowIcon,
  Pause as PauseIcon,
} from '@mui/icons-material';
/**
 * MasterControls - Centralized sync and playback controls
 * Positioned between videos in comparison view
 */
function MasterControls({
  syncMode,
  isPlaying,
  playbackRate,
  skipSeconds = 5,
  onSyncModeToggle,
  onPlay,
  onPause,
  onSkipBackward,
  onSkipForward,
  onSetSkipSeconds,
  className = '',
}) {
  const handlePlayPause = useCallback(() => {
    if (isPlaying) {
      onPause?.();
    } else {
      onPlay?.();
    }
  }, [isPlaying, onPlay, onPause]);

  const handleSkipSecondsChange = useCallback(
    (event) => {
      console.log('skip seconds', event.target.value);
      onSetSkipSeconds?.(parseInt(event.target.value));
    },
    [onSetSkipSeconds]
  );

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        minWidth: 120,
        py: 4,
      }}
    >
      {/* Playback Controls Group */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minWidth: 200,
          justifyContent: 'center',
        }}
      >
        {/* Skip backward */}
        <IconButton
          onClick={() => onSkipBackward?.(skipSeconds)}
          size="small"
          sx={{ color: 'primary.main' }}
        >
          <NavigateBeforeIcon />
        </IconButton>

        {/* Skip seconds dropdown */}
        <FormControl size="small" sx={{ minWidth: 50 }}>
          <Select
            value={skipSeconds}
            onChange={handleSkipSecondsChange}
            displayEmpty
          >
            <MenuItem value={1}>1s</MenuItem>
            <MenuItem value={2}>2s</MenuItem>
            <MenuItem value={3}>3s</MenuItem>
            <MenuItem value={5}>5s</MenuItem>
            <MenuItem value={10}>10s</MenuItem>
            <MenuItem value={15}>15s</MenuItem>
            <MenuItem value={30}>30s</MenuItem>
          </Select>
        </FormControl>

        {/* Play/Pause button */}
        <IconButton
          onClick={handlePlayPause}
          size="small"
          sx={{
            color: 'primary.main',
            backgroundColor: 'primary.main',
            color: 'white',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
        </IconButton>

        {/* Skip forward */}
        <IconButton
          onClick={() => onSkipForward?.(skipSeconds)}
          size="small"
          sx={{ color: 'primary.main' }}
        >
          <NavigateNextIcon />
        </IconButton>
      </Box>

      {/* Sync Status */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Button
          variant="contained"
          size="small"
          onClick={onSyncModeToggle}
          sx={{
            minWidth: 120,
            backgroundColor: syncMode === 'lapStart' ? '#4a90e2' : '#ff9800',
            '&:hover': {
              backgroundColor: syncMode === 'lapStart' ? '#357ae0' : '#f57c00',
            },
          }}
        >
          {syncMode === 'lapStart' ? 'Lap Start Synced' : 'Custom Synced'}
        </Button>
      </Box>
    </Box>
  );
}

export default MasterControls;
